/**
 * The one sentence shown wherever a surface is restricted to Hakio staff — header tabs, view pills and
 * inspector cards all state it identically, so a planner who sees the orange treatment anywhere reads
 * the same explanation.
 */
export const HAKIO_ONLY_TOOLTIP = "This content is only accessible to Hakio members"
